import { startCase } from "lodash";
import _ from "lodash";
import stbServer from "./axios";

export const getDisplayName = (user) => {
  // if (user.user_type === "business") {
  //     return startCase(user?.business?.business_name);
  //   } else {
  //     return startCase(`${user?.first_name} ${user?.last_name}`);
  //   }
  return startCase(`${user?.first_name} ${user?.last_name}`);
};

export const periodFilters = [
  { value: "daily", label: "daily" },
  { value: "weekly", label: "weekly" },
  { value: "monthly", label: "monthly" },
  { value: "yearly", label: "yearly" },
];

export const removeCodeFromPhone = (phone, code) => {
  if (_.startsWith(phone, code)) {
    return _.join(_.slice(phone, code.length), "");
  } else {
    console.error("Error: Code not found at the beginning of the phone string");
    return phone;
  }
};

/**
 * Splits a phone number with country code into country code and number
 * Supports US (1) and BR (55) country codes
 * Handles formats: "15551234567", "+1 5551234567", "+15551234567", "5511987654321", etc.
 * @param {string} fullPhoneNumber - Full phone number with country code (e.g., "15551234567", "+1 5551234567", or "5511987654321")
 * @returns {Object} - { countryCode: string, number: string }
 */
export const splitPhoneNumber = (fullPhoneNumber) => {
  if (!fullPhoneNumber) {
    return { countryCode: "", number: "" };
  }

  // Remove + prefix and any spaces, keep only digits
  let phoneStr = fullPhoneNumber.toString().trim();
  // Remove + prefix if present
  if (phoneStr.startsWith("+")) {
    phoneStr = phoneStr.substring(1);
  }
  // Remove all spaces
  phoneStr = phoneStr.replace(/\s/g, "");
  // Remove any non-digit characters (keep only digits)
  phoneStr = phoneStr.replace(/\D/g, "");

  // Brazil country code (55) - check first to avoid matching US (1) prefix
  if (phoneStr.startsWith("55")) {
    return {
      countryCode: "55",
      number: phoneStr.substring(2),
    };
  }

  // US country code (1)
  if (phoneStr.startsWith("1")) {
    return {
      countryCode: "1",
      number: phoneStr.substring(1),
    };
  }

  // If no country code detected, return as-is (assume it's just the number)
  return {
    countryCode: "",
    number: phoneStr,
  };
};

/**
 * Combines country code and phone number into full number with + sign and space
 * @param {string} countryCode - Country dial code (e.g., "1" or "55")
 * @param {string} number - Phone number without country code (e.g., "5551234567")
 * @returns {string} - Full phone number with country code, + sign, and space (e.g., "+1 5551234567")
 */
export const combinePhoneNumber = (countryCode, number) => {
  if (!countryCode && !number) {
    return "";
  }
  if (!countryCode) {
    return number || "";
  }
  if (!number) {
    return countryCode ? `+${countryCode}` : "";
  }
  return `+${countryCode} ${number}`;
};

export const DESIGNATION_OPTION = [
  {
    name: "CEO",
    value: "CEO",
  },
  {
    name: "UBO",
    value: "UBO",
  },
  {
    name: "Shareholder",
    value: "Shareholder",
  },
  {
    name: "Director",
    value: "Director",
  },
  {
    name: "Other authorized representatives",
    value: "Other authorized representatives",
  },
];

// Helper function to parse errors
export const parseErrorsWithFieldNames = (errors) => {
  const messages = [];

  for (const key in errors) {
    if (Array.isArray(errors[key])) {
      // Field-specific errors (e.g., { username: ["This field is required."] })
      errors[key].forEach((message) => {
        messages.push({ field: key, message });
      });
    } else if (typeof errors[key] === "object") {
      // Nested errors (e.g., { user: { email: ["Invalid email"] } })
      const nestedMessages = parseErrorsWithFieldNames(errors[key]);
      nestedMessages.forEach((nestedError) => {
        messages.push({
          field: `${key}.${nestedError?.field}`,
          message: nestedError?.message,
        });
      });
    } else if (typeof errors[key] === "string") {
      // String errors (less common)
      messages.push({ field: key, message: errors[key] });
    }
  }

  return messages;
};

// Common error handler function
export const handleApiErrors = (error) => {
  let errorMessages = [{ field: null, message: "An unknown error occurred." }];

  if (error.response) {
    // Error response from the server
    const { status, data } = error.response;

    if (data) {
      if (data?.detail || data?.message) {
        // Handles { detail: "Error message" }
        if (Array.isArray(data?.message)) {
          // Handles Error of type array
          errorMessages = data?.message?.map((message) => ({
            field: null,
            message,
          }));
        } else if (Array.isArray(data?.detail)) {
          // Handles Error of type array
          errorMessages = data?.detail?.map((message) => ({
            field: null,
            message,
          }));
        } else {
          errorMessages = [
            { field: null, message: data?.detail || data?.message },
          ];
        }
      } else if (
        data?.non_field_errors &&
        Array.isArray(data?.non_field_errors)
      ) {
        // Handles { non_field_errors: ["Error message"] }
        errorMessages = data?.non_field_errors.map((message) => ({
          field: null,
          message,
        }));
      } else if (Array.isArray(data)) {
        // Handles Error of type array
        errorMessages = data?.map((message) => ({ field: null, message }));
      } else if (typeof data === "object") {
        // Handles field-specific or nested errors
        errorMessages = parseErrorsWithFieldNames(data);
      }
    } else {
      // If no data is returned but there's a status code
      if (status === 403) {
        errorMessages = [
          { field: null, message: "Forbidden: Access is denied." },
        ];
      } else if (status === 500) {
        errorMessages = [
          {
            field: null,
            message: "Internal Server Error. Please try again later.",
          },
        ];
      } else {
        errorMessages = [
          {
            field: null,
            message: `Unexpected error occurred. Status code: ${status}`,
          },
        ];
      }
    }
  } else if (error?.request) {
    // Network errors or no response received
    errorMessages = [
      {
        field: null,
        message: "No response from the server. Please check your connection.",
      },
    ];
  } else if (error?.message) {
    // JavaScript Error object
    errorMessages = [{ field: null, message: error?.message }];
  } else if (typeof error === "string") {
    // Non-object errors
    errorMessages = [{ field: null, message: error }];
  }

  return errorMessages;
};

//Searchable Select Fetch Function Call
export const searchableSelectFetchOptions = async (
  url,
  query,
  additionalParams,
  customReturn
) => {
  const apiUrl = query ? `${url}?search=${query}` : `${url}`; // No search parameter when query is empty

  const response = await stbServer.get(apiUrl, {
    params: {
      ...additionalParams,
    },
  });
  return customReturn
    ? customReturn(response)
    : response?.data?.results?.map((item) => ({
        label: item?.business_name, // Adjust based on your API response
        value: item?.id,
      }));
};

export function formatString(inputString) {
  // Replace underscores with spaces and capitalize each word
  return inputString
      .replace(/_/g, ' ') // Replace underscores with spaces
      .split(' ')         // Split into an array of words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(' ');         // Join the words back into a single string
}
